import { Button, Col, ControlLabel, FormControlStatic, Modal, Row } from 'react-bootstrap';
import { ICenterFollowUpLabOption } from '@nkr/models/index';

interface IProps {
    show: boolean,
    data: ICenterFollowUpLabOption,
    onYes: () => void,
    onNo: () => void
}

const ConfirmDelete = (props: IProps) => {
    if (props.data == null)
        return null;

    const { id, centerId, isFollowUpNeeded, isDeleted, optionText, filePath  } = props.data;

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Confirm Follow Up Delete
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className='text-center' style={{ marginBottom: 10 }}>Are you sure you want to delete the following lab option?</div>

                <Row>
                    <Col xs={12} lg={6} componentClass={ControlLabel} style={{ textAlign: 'right' }}>Lab Option:</Col>
                    <Col xs={12} lg={6} componentClass={FormControlStatic}>{optionText}</Col>
                </Row>
      
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onYes}>Yes, Delete</Button>
                <Button onClick={props.onNo}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDelete;